import { render, staticRenderFns } from "./Propietario.vue?vue&type=template&id=3f168c5d&"
import script from "./Propietario.vue?vue&type=script&lang=js&"
export * from "./Propietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports